import React from 'react';

import {
  SkillTag,
  SkillsContainer,
  SkillsContent,
  SkillsH1,
  SkillsWrapper,
} from './SkillsElements';

const Skills = () => {
  return (
    <SkillsContainer id="skills">
      <SkillsWrapper>
        <SkillsH1>Skills</SkillsH1>
        <SkillsContent>
          <SkillTag>Mechanical Systems</SkillTag>
          <SkillTag>Machine Design</SkillTag>
          <SkillTag>Product Development</SkillTag>
          <SkillTag>Robotics & Automation</SkillTag>
          <SkillTag>Manufacturing</SkillTag>
          <SkillTag>3D Printing</SkillTag>
          <SkillTag>Software Design</SkillTag>
          <SkillTag>Computer Vision</SkillTag>
          <SkillTag>Edge Computing</SkillTag>
          <SkillTag>Leadership</SkillTag>
          <SkillTag>Team Building</SkillTag>
        </SkillsContent>
        <SkillsH1 style={{ marginTop: '48px' }}>Tools/Technologies</SkillsH1>
        <SkillsContent>
          <SkillTag>AutoCAD</SkillTag>
          <SkillTag>Autodesk Fusion 360</SkillTag>
          <SkillTag>Ansys</SkillTag>
          <SkillTag>CATIA V5</SkillTag>
          <SkillTag>SolidWorks</SkillTag>
          <SkillTag>CNC</SkillTag>
          <SkillTag>Simulator</SkillTag>
          <SkillTag>Flashforge</SkillTag>
          <SkillTag>Robot Operating System</SkillTag>
          <SkillTag>Gazebo</SkillTag>
          <SkillTag>RViz</SkillTag>
          <SkillTag>Eagle</SkillTag>
          <SkillTag>Ultimaker Cura</SkillTag>
          <SkillTag>Linux</SkillTag>
          <SkillTag>Mavros</SkillTag>
          <SkillTag>SLAM</SkillTag>
          <SkillTag>Nav2 Stack</SkillTag>
        </SkillsContent>
        <SkillsH1 style={{ marginTop: '48px' }}>Languages</SkillsH1>
        <SkillsContent>
          <SkillTag>Python</SkillTag>
          <SkillTag>C</SkillTag>
          <SkillTag>HTML/CSS</SkillTag>
          <SkillTag>Javascript</SkillTag>
        </SkillsContent>
      </SkillsWrapper>
    </SkillsContainer>
  );
};

export default Skills;
